"use strict";

require("core-js/modules/es6.array.find");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.fill");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.replace");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactKonva = require("react-konva");

var _ramda = require("ramda");

var _Transformer = _interopRequireDefault(require("./Transformer"));

var _Rectangle = _interopRequireDefault(require("./elements/Rectangle"));

var _Circle = _interopRequireDefault(require("./elements/Circle"));

var _Text = _interopRequireDefault(require("./elements/Text"));

var _Background = _interopRequireDefault(require("./Background"));

var _Image = _interopRequireDefault(require("./elements/Image"));

var _Qr = _interopRequireDefault(require("./elements/Qr"));

var _Curve = _interopRequireDefault(require("./elements/Curve"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var ELEMENTS = {
  text: _Text.default,
  rect: _Rectangle.default,
  circle: _Circle.default,
  curve: _Curve.default,
  image: _Image.default,
  qr: _Qr.default
};

var Canvas =
/*#__PURE__*/
function (_Component) {
  _inherits(Canvas, _Component);

  function Canvas() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Canvas);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Canvas)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.handleStageMouseDown = function (e) {
      var _this$props = _this.props,
          onChangeCurrent = _this$props.onChangeCurrent,
          elements = _this$props.elements,
          selectedType = _this$props.selectedType,
          onAddElement = _this$props.onAddElement,
          current = _this$props.current,
          onAddAnchor = _this$props.onAddAnchor,
          anchorsEditable = _this$props.anchorsEditable;

      if (selectedType) {
        onAddElement(e.evt.layerX, e.evt.layerY);
        return;
      }

      if (e.target === e.target.getStage()) {
        onChangeCurrent(null);
        return;
      }

      if (e.target.getParent().className === 'Transformer' || e.target.attrs.className === 'anchor') {
        return;
      }

      var name = (e.target.name() || '').replace('-helper', '');
      var element = (0, _ramda.find)((0, _ramda.propEq)('name', name), elements);

      if (element && !anchorsEditable) {
        onChangeCurrent(name);
      } else {
        current && current.anchors && anchorsEditable ? onAddAnchor(e.evt.layerX, e.evt.layerY) : onChangeCurrent(null);
      }
    };

    _this.renderElement = function (element) {
      var _this$props2 = _this.props,
          onChangeCurrentElement = _this$props2.onChangeCurrentElement,
          getFileUrl = _this$props2.getFileUrl;
      var Component = ELEMENTS[element.type];
      return _react.default.createElement(Component, {
        key: element.name,
        element: element,
        onChange: onChangeCurrentElement,
        layer: _this.layer,
        getFileUrl: getFileUrl
      });
    };

    _this.getElementsWithAnchors = function () {
      var elements = _this.props.elements;
      return (0, _ramda.filter)((0, _ramda.has)('anchors'), elements);
    };

    _this.onDragAnchor = function (e, index) {
      var _this$props3 = _this.props,
          onChangeCurrentElement = _this$props3.onChangeCurrentElement,
          current = _this$props3.current;

      if (current) {
        var x = e.target.x();
        var y = e.target.y();
        onChangeCurrentElement(_objectSpread({}, current, {
          x: index ? current.x : x,
          y: index ? current.y : y,
          anchors: (0, _ramda.update)(index, _objectSpread({}, current.anchors[index], {
            x: x,
            y: y
          }), current.anchors)
        }));
      }
    };

    _this.renderAnchors = function (element) {
      var _this$props4 = _this.props,
          onChangeCurrentAnchor = _this$props4.onChangeCurrentAnchor,
          currentAnchor = _this$props4.currentAnchor;
      var show = (0, _ramda.pathEq)(['current', 'name'], element.name, _this.props);
      return show && element.anchors.map(function (anchor, index) {
        return _react.default.createElement(_reactKonva.Circle, {
          key: "anchor-".concat(element.name, "-").concat(index),
          className: "anchor",
          x: anchor.x,
          y: anchor.y,
          fill: "white",
          stroke: "rgb(0, 161, 255)",
          strokeWidth: (0, _ramda.equals)(currentAnchor, {
            name: element.name,
            index: index
          }) ? 2 : 1,
          width: 10,
          height: 10,
          onDragMove: function onDragMove(e) {
            return _this.onDragAnchor(e, index);
          },
          onDragStart: function onDragStart() {
            return onChangeCurrentAnchor(element.name, index);
          },
          onClick: function onClick() {
            return onChangeCurrentAnchor(element.name, index);
          },
          draggable: true
        });
      });
    };

    _this.renderAnchorBorder = function (element) {
      var headAnchor = (0, _ramda.head)(element.anchors);
      var show = (0, _ramda.pathEq)(['current', 'name'], element.name, _this.props) && headAnchor;
      var points = (0, _ramda.unnest)(element.anchors.map(function (_ref) {
        var x = _ref.x,
            y = _ref.y;
        return [x, y];
      }));
      return show && _react.default.createElement(_reactKonva.Line, {
        stroke: "rgb(0, 161, 255)",
        strokeWidth: 1,
        key: "anchor-border-".concat(element.name),
        points: element.close ? [].concat(_toConsumableArray(points), [headAnchor.x, headAnchor.y]) : points
      });
    };

    return _this;
  }

  _createClass(Canvas, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props5 = this.props,
          width = _this$props5.width,
          height = _this$props5.height,
          current = _this$props5.current,
          elements = _this$props5.elements,
          settings = _this$props5.settings,
          getTransformerRef = _this$props5.getTransformerRef,
          getStageRef = _this$props5.getStageRef,
          getFileUrl = _this$props5.getFileUrl;
      var elementsWithAnchors = this.getElementsWithAnchors();
      return _react.default.createElement(_reactKonva.Stage, {
        width: width,
        height: height,
        onMouseDown: this.handleStageMouseDown,
        ref: getStageRef
      }, _react.default.createElement(_reactKonva.Layer, null, _react.default.createElement(_reactKonva.Rect, {
        width: width,
        height: height,
        fill: settings.fill
      })), settings.background && _react.default.createElement(_reactKonva.Layer, null, _react.default.createElement(_Background.default, {
        settings: settings,
        width: width,
        height: height,
        getFileUrl: getFileUrl
      })), _react.default.createElement(_reactKonva.Layer, {
        ref: function ref(node) {
          return _this2.layer = node;
        }
      }, elements.map(this.renderElement), _react.default.createElement(_Transformer.default, {
        current: current,
        getRef: getTransformerRef
      })), _react.default.createElement(_reactKonva.Layer, null, elementsWithAnchors.map(this.renderAnchorBorder), elementsWithAnchors.map(this.renderAnchors)));
    }
  }]);

  return Canvas;
}(_react.Component);

exports.default = Canvas;
Canvas.propTypes = {
  width: _propTypes.default.number,
  height: _propTypes.default.number,
  current: _propTypes.default.object,
  onChangeCurrent: _propTypes.default.func,
  onAddElement: _propTypes.default.func,
  onChangeCurrentElement: _propTypes.default.func,
  onChangeCurrentProp: _propTypes.default.func,
  onAddAnchor: _propTypes.default.func,
  anchorsEditable: _propTypes.default.bool,
  onChangeCurrentAnchor: _propTypes.default.func,
  currentAnchor: _propTypes.default.object,
  elements: _propTypes.default.arrayOf(_propTypes.default.object),
  getTransformerRef: _propTypes.default.func,
  getStageRef: _propTypes.default.func,
  getFileUrl: _propTypes.default.func
};